import {useEffect, useState} from 'react'
import classes from './agreements.module.scss'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { hidePopup } from '../../store/reducers/ContractReducer/ContractReducer'
import classNames from 'classnames';
import { contractService } from '../../api/contractService'
import { toast } from 'react-toastify'

const AddAgreements = () => {

    const dispatch = useDispatch()
    const id = useSelector(state=>state.ContractSlice.id)
    const [card, setCard] = useState()
    const { handleSubmit, register,formState: {errors}, setValue } = useForm()
    // const [value, setValue] = useState({
    //     "CISH": 0,
    //     "IGH": 0,
    //     "Express": 0,
    //     "Gistology": 0
    // })

    const onClose = () =>{
        dispatch(hidePopup())
    }

    const formData = {
        "legend": 'Дослідження',
        "id":5,
        "type": 'number',
        "required": true,
        "name": 'IGH',
        "options": true,
        "props":[
            {
            "legend": 'ІГХ',
            "id":5,
            "type": 'number',
            "required": true,
            "name": 'IGH',
            "levels": [],
            "options": true,
            },{
            "legend": 'Гістологія',
            "id":6,
            "type": 'number',
            "required": true,
            "name": 'Gistology',
            "levels": [
                "lev1",
                "lev2",
                "lev3",
                "lev4",
                "lev5"
            ],
            "options": true,
            },{
            "legend": 'Експрес',
            "id":7,
            "type": 'number',
            "required": true,
            "name": 'Express',
            "levels": [],
            "options": true,
            },{
            "legend": 'CISH',
            "id":8,
            "type": 'number',
            "required": true,
            "name": 'CISH',
            "levels": [],
            "options": true,
            },
        ]
    }

    const onSubmit = (data) => {
       setCard({
        "CISH": data.CISH,
        "ІГХ": data.IGH,
        "Експрес": data.Express,
        "Гістологія": {
                "1": data.lev1,
                "2": data.lev2,
                "3": data.lev3,
                "4": data.lev4,
                "5": data.lev5
            },  
       })
    }

    const addNew = async(data) =>{
        await contractService.addAgreements(id,data).then(res=>{
            if(res){
                dispatch(hidePopup())
                toast.apply('Дослідження додані')
            }
        })
    }

    useEffect(()=>{
        if(card !== undefined){
            addNew(card)
        }
    },[card])

    useEffect(()=>{
        contractService.getContract(id).then(res=>{
            if(res?.data){
                if(res.data.additionalAgreements.length > 0){
                    res.data.additionalAgreements.map(el=>{
                        if(Object.keys(el)[0] == 'CISH'){
                            setValue('CISH', el[Object.keys(el)[0]].quantity)
                        } else if (Object.keys(el)[0] == 'ІГХ'){
                            setValue('IGH', el[Object.keys(el)[0]].quantity)
                        } else if (Object.keys(el)[0] == 'Експрес'){
                            setValue('Express', el[Object.keys(el)[0]].quantity)
                        } else if (Object.keys(el)[0] == 'Гістологія'){
                            console.log(el[Object.keys(el)[0]].complexity[1])
                            setValue('lev1', el[Object.keys(el)[0]].complexity[1].quantity)
                            setValue('lev2', el[Object.keys(el)[0]].complexity[2].quantity)
                            setValue('lev3', el[Object.keys(el)[0]].complexity[3].quantity)
                            setValue('lev4', el[Object.keys(el)[0]].complexity[4].quantity)
                            setValue('lev5', el[Object.keys(el)[0]].complexity[5].quantity)
                        }
                    })
                } else {
                    setValue('CISH', 0)
                    setValue('IGH', 0)
                    setValue('Express', 0)
                    setValue('Gistology', 0)
                }
            }
        })
    },[id])


  return (
    <div className={classes.container}>
        <button onClick={onClose} className={classes.closeButton}>
            X
        </button>   
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
            {formData.props.map((props, index)=>(
            <div className={classes.form__box__register} key={index}>
            <div><label>{props.legend}</label></div>
            {props.levels.length === 0 ? 
            <input
                className={classNames(classes.form__input, {[classes.errorInput]: errors[props.name]})}
                type={props.type}
                name={props.name}
                defaultValue={0}
                {...register(props.name, {required: props.required})}
            />: props.levels.map((lev,index)=>
                    (<div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                    <div><label>Категорія {index + 1}</label></div>
                    <input
                        style={{marginBottom: '5px'}}
                        className={classNames(classes.form__input__agr, {[classes.errorInput]: errors[props.name]})}
                        type={props.type}
                        name={lev}
                        placeholder='Введіть свої значення...'
                        {...register(lev)}
                    />
                    </div>)
                )} 
            </div>
            ))}
            <button className={classes.form__button} type='submit'>Додати</button>
        </form>
    </div>
  )
}

export default AddAgreements